export default __webpack_public_path__ + "static/media/product_4.3f41deb0.png";